import { useState, useEffect } from "react";
import { glassCard } from "../styles/glass";

function BulletinBoardSlider({ bulletins }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === bulletins?.length - 1 ? 0 : prev + 1
      );
    }, 10000); // Change slide every 3 sec
    return () => clearInterval(interval);
  }, [bulletins?.length]);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? bulletins?.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === bulletins?.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className={`relative flex h-full min-h-[280px] w-full flex-col p-4 px-6 sm:min-h-[min(50vh,520px)] ${glassCard}`}>
      {/* Heading */}
      <h2 className="text-lg font-semibold text-white ">Bulletin Board</h2>

      {/* Carousel */}
      <div className="relative h-full   md:h-full overflow-hidden rounded-lg">
        {bulletins?.map((item, index) => (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full transition-transform duration-700 ease-in-out ${
              index === currentIndex ? "translate-x-0" : "translate-x-full"
            }`}
          >
            <div className=" pt-4 mx-1 rounded-md h-full flex flex-col justify-between">
              <div className="mb-2">
                <h3 className="text-base font-semibold text-white">Title</h3>
                <p className="text-white text-sm mt-1">{item.title}</p>
              </div>
             <hr className="my-1 border-[1.5px] border-t border-borderGray" />
              <div className="mb-2">
                <h3 className="text-base font-semibold text-white">Category</h3>
                <p className="text-white text-sm mt-1">{item.category}</p>
              </div>
             <hr className="my-1 border-[1.5px] border-t border-borderGray" />

              <div>
                <h3 className="text-base font-semibold  text-white">Description</h3>
                <p className="text-white line-clamp-3 text-sm mt-1">{item.message}</p>
              </div>
            </div>
          </div>
        ))}



        {/* Indicators */}
        {/* <div className="absolute  -mb-1 bottom-1 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {bulletins?.map((_, idx) => (
            <span
              key={idx}
              className={`w-2 h-2 rounded-full ${
                idx === currentIndex ? "bg-white" : "bg-white/50"
              }`}
            />
          ))}
        </div> */}
      </div>
              {/* Prev/Next Buttons */}
        <button
          onClick={prevSlide}
          className="absolute h-4 w-4 flex items-center justify-center top-1/2 left-[4px] transform -translate-y-1/2   rounded-full"
        >
         <span className="text-3xl text-white -mt-1">
             ‹
         </span>
        </button>
        <button
          onClick={nextSlide}
          className="absolute  text-white h-4 w-4 flex items-center justify-center top-1/2 right-[4px] transform -translate-y-1/2   rounded-full"
        >
          <span className="text-3xl -mt-1">
             ›
          </span>
        </button>
    </div>
  );
}

export default BulletinBoardSlider;
